import { render, staticRenderFns } from "./sendInfo.vue?vue&type=template&id=6d5a3910"
import script from "./sendInfo.vue?vue&type=script&lang=js"
export * from "./sendInfo.vue?vue&type=script&lang=js"
import style0 from "./sendInfo.vue?vue&type=style&index=0&id=6d5a3910&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports